export const STATIC_ROUTES: ReadonlySet<string> = new Set<string>([
  'office',
  'purchase',
  'plan',
  'faq',
  'support',
  'feeSchedule',
  'privacy',
  'terms-of-use',
  'ancillary-benefits',
  'ancillary-search'
]);

export function isStaticRoute(segment: string): boolean {
  return STATIC_ROUTES.has(segment);
}
